import api from '../../services/api'

export default {
  namespaced: true,
  
  state: {
    posts: [],
    loading: false,
    error: null
  },
  
  getters: {
    posts: state => state.posts,
    loading: state => state.loading,
    error: state => state.error
  },
  
  mutations: {
    SET_POSTS(state, posts) {
      state.posts = posts
    },
    ADD_POST(state, post) {
      state.posts.unshift(post)
    },
    UPDATE_POST(state, updatedPost) {
      const index = state.posts.findIndex(p => p.postId === updatedPost.postId)
      if (index !== -1) {
        state.posts.splice(index, 1, updatedPost)
      }
    },
    DELETE_POST(state, postId) {
      state.posts = state.posts.filter(p => p.postId !== postId)
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },
  
  actions: {
    async fetchPosts({ commit }, filters = {}) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        const response = await api.get('/posts', { params: filters })
        commit('SET_POSTS', response.data.posts)
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || 'Failed to fetch posts')
      } finally {
        commit('SET_LOADING', false)
      }
    },
    
    async createPost({ commit }, postData) {
      try {
        const response = await api.post('/posts', postData)
        commit('ADD_POST', response.data.post)
        return { success: true, post: response.data.post }
      } catch (error) {
        return { success: false, error: error.response?.data?.message || 'Failed to create post' }
      }
    },
    
    async updatePost({ commit }, { postId, postData }) {
      try {
        const response = await api.put(`/posts/${postId}`, postData)
        commit('UPDATE_POST', response.data.post)
        return { success: true }
      } catch (error) {
        return { success: false, error: error.response?.data?.message || 'Failed to update post' }
      }
    },
    
    async deletePost({ commit }, postId) {
      try {
        await api.delete(`/posts/${postId}`)
        commit('DELETE_POST', postId)
        return { success: true }
      } catch (error) {
        return { success: false, error: error.response?.data?.message || 'Failed to delete post' }
      }
    }
  }
}
